var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3336 9.66703V10.3336C19.3336 10.7018 19.0352 11.0003 18.667 11.0003H11.0003V18.667C11.0003 19.0351 10.7018 19.3336 10.3336 19.3336H9.66702C9.29882 19.3336 9.00032 19.0351 9.00032 18.667V11.0003H1.33366C0.965473 11.0003 0.666992 10.7018 0.666992 10.3336V9.66703C0.666992 9.29883 0.965473 9.00033 1.33366 9.00033H9.00032V1.33365C9.00032 0.965463 9.29882 0.666992 9.66702 0.666992H10.3336C10.7018 0.666992 11.0003 0.965463 11.0003 1.33365V9.00033H18.667C19.0352 9.00033 19.3336 9.29883 19.3336 9.66703Z",
    fill: "url(#paint0_linear_625_1344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_625_1344",
    x1: 0.667085,
    y1: 10.0005,
    x2: 19.3336,
    y2: 10.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqOpen);
export default __webpack_public_path__ + "static/media/faqOpen.bfc7fd921501c7bc3d93dc1676ed9caf.svg";
export { ForwardRef as ReactComponent };